import {
	Drawer,
	List,
	ListItem,
	ListItemButton,
	ListItemText,
	ListItemAvatar,
	Collapse,
	Divider,
	IconButton,
	Box,
	Avatar,
	Tooltip,
} from "@mui/material";

import { ExpandLess, ExpandMore, MoreHoriz } from "@mui/icons-material";

import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setStarredPeople } from "state/reducers/authReducer";

import SearchPeopleAutocomplete from "components/SearchPeopleAutocomplete";
import { useNavigate } from "react-router-dom";

export const PeopleDrawerContent = ({ ...props }) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const people = useSelector((state) => state.auth.starredPeople);
	const token = useSelector((state) => state.auth.token);
	const currentWorkspaces = useSelector(
		(state) => state.auth.user.currentWorkspaces
	);

	// get starred people and groups on mount
	useEffect(() => {
		const getStarredPeople = async () => {
			// get starred people
			const url = new URL(
				`${process.env.REACT_APP_PORT}/people/getStarredPeople`
			);
			const response = await fetch(url, {
				method: "GET",
				headers: { Authorization: `Bearer ${token}` },
			});
			const data = await response.json();
			console.log(data);
			if (response.status === 200) {
				dispatch(setStarredPeople(data));
			}
		};
		getStarredPeople();
	}, [currentWorkspaces]);

	const handleValueChange = async (event, value) => {
		//setPerson(value);
		navigate(`/people/${value.resource}`);
	};
	const [openPeople, setOpenPeople] = useState(true);
	const [openGroups, setOpenGroups] = useState(true);
	const handlePeopleClick = () => {
		setOpenPeople(!openPeople);
	};
	const handleGroupsClick = () => {
		setOpenGroups(!openGroups);
	};
	const handlePeopleSecondaryAction = (person) => {
		console.log(person);
	};
	const sidebar = [
		{
			name: "People",
			icon: "StarBorder",
			open: openPeople,
			handleClick: handlePeopleClick,
			handleSecondaryAction: handlePeopleSecondaryAction,
		},
		/*{
            name: 'Groups',
            icon: 'StarBorder',
            open: openGroups,
            handleClick: handleGroupsClick,
        },*/
	];

	return (
		<>
			<SearchPeopleAutocomplete
				placeholder="Search people"
				handleValueChange={handleValueChange}
				sx={{ m: 2 }}
			/>

			<List>
				{sidebar?.map((option, i) => (
					<Box key={option.name}>
						{/* Option Header with collapsable button*/}
						<ListItem
							secondaryAction={
								<IconButton
									edge="end"
									aria-label="delete"
									onClick={option.handleClick}
									disableTouchRipple
								>
									{option.open ? <ExpandLess /> : <ExpandMore />}
								</IconButton>
							}
						>
							<ListItemText primary={option.name} />
						</ListItem>

						<Collapse in={option.open} timeout="auto" unmountOnExit>
							<List disablePadding dense>
								{option.name === "People" &&
									people?.map((person) => (
										<ListItem
											secondaryAction={
												<IconButton
													onClick={() => option.handleSecondaryAction(person)}
													edge="end"
													aria-label="delete"
												>
													<MoreHoriz />
												</IconButton>
											}
											key={person.resourceName}
											disablePadding
										>
											<Tooltip title={person.email}>
												<ListItemButton
													onClick={() =>
														navigate(`/people/${person.resourceName}`)
													}
													disableTouchRipple
												>
													<ListItemAvatar>
														<Avatar
															alt={person.name || person.email}
															src={person.photo}
															sx={{ width: 32, height: 32 }}
														/>
													</ListItemAvatar>
													<ListItemText
														primary={person.name || person.email}
														primaryTypographyProps={{
															textOverflow: "ellipsis",
															overflow: "hidden",
															whiteSpace: "nowrap",
														}}
													/>
												</ListItemButton>
											</Tooltip>
										</ListItem>
									))}
								{option.name === "Groups" && null}
							</List>
						</Collapse>

						{i !== sidebar.length - 1 && (
							<Box mt={option.open && people?.length > 0 && "1rem"}>
								<Divider />
							</Box>
						)}
					</Box>
				))}
			</List>
		</>
	);
};
